<template>
  <div class="flex flex-col w-full">
    <Toast position="top-[48px]"></Toast>
    <div class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
      Reset Email
    </div>
    <div class="text-[1rem] leading-[1.5rem] text-[#433D31] font-semibold pt-[8px]">
      Great! Please enter your mobile number.
    </div>

    <div class="mt-[40px]">
      <label class="block text-[0.875rem] leading-[1.25rem] text-[#191817] font-semibold mb-[8px]">
        Mobile number
      </label>
      <div>
        <vue-tel-input
          :class="[
            'bg-white p-[16px] rounded-[8px] border-[1px] border-solid border-[#C3C2C1] min-h-[56px]',
            hasError
              ? 'border-[#B80A0A] focus:border-[#B80A0A]'
              : 'border-[#C3C2C1] focus:border-[#056DFF]',
          ]"
          v-model="mobileNumber"
          :dropdown-options="{
            showDialCodeInList: true,
            showDialCodeInSelection: true,
            showFlags: true,
            showSearchBox: true,
          }"
          default-country="SG"
          type="tel"
          :preferred-countries="['SG']"
          :input-options="{
            placeholder: '',
            type: 'tel',
            autofocus: true,
          }"
          @on-input="onInput"
          @validate="validateMobileNumber"
        />
      </div>
      <p v-if="hasError" class="text-[1rem] text-[#B80A0A] leading-[1.5rem] mt-[4px] block">
        {{ errorMessage }}
      </p>
    </div>
    <BottomButton text="Next" :disabled="!canSave" @click="handleOnComplete" class="my-[32px]" />
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
import Toast from '@/components/common/Toast.vue';

export default {
  components: {
    BottomButton,
    Toast,
  },
  data() {
    return {
      mobileNumber: '',
      loading: false,
      hasError: false,
      errorMessage: '',
      phoneObj: {},
      isInvalidPhoneNumber: false,
    };
  },
  computed: {
    canSave() {
      return this.mobileNumber.length > 0;
    },
  },
  methods: {
    async handleOnComplete() {
      if (this.isInvalidPhoneNumber) {
        this.hasError = true;
        this.errorMessage = 'Please enter a valid mobile number.';
        return;
      }

      this.hasError = false;
      const countryCallingCode = this.phoneObj.countryCallingCode;
      const nationalNumber = this.phoneObj.nationalNumber;
      this.loading = true;
      try {
        this.$store.commit('forgotCredentials/setMobileData', {
          countryCode: countryCallingCode,
          mobileNumber: nationalNumber,
        });
        await this.$store.dispatch('forgotCredentials/sendMobileOtp', {
          countryCode: countryCallingCode,
          contactNumber: nationalNumber,
        });
        this.$emit('next');
      } catch (error) {
        console.error(error.stack);
      } finally {
        this.loading = false;
      }
    },
    validateMobileNumber(phoneObj) {
      this.isInvalidPhoneNumber = !phoneObj.valid;
    },
    onInput(number, phoneObj) {
      if (!phoneObj) return;
      this.phoneObj = phoneObj;
    },
  },
};
</script>
